import styled from 'styled-components';
import {MAIN_COLOR} from "../../globalThemes";

export const PageHeaderElement = styled.div`
    width: 330px;
    height: 70px;
    display: flex;
    align-items: center;
    background-color: #1F1F1F15;
    clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);
    user-select: none; 
`;

export const StyledPageHeader = styled.div`
    width: 200px;
    height: 50px;
    text-align: center;
    background-color: #1F1F1F;
    clip-path: polygon(0 0, 100% 0, 80% 100%, 0% 100%);
    display: flex;
    align-items: center;
`;

export const StyledPageTitle = styled.p`
    font-size: 20px;    
    color: white;
    font-family: BlenderProBold, serif;
    letter-spacing: 1px;
    margin-left: 35px;
    
    &:before {
        content: "# ";
        color: ${MAIN_COLOR};
        letter-spacing: 1px;
        font-size: 26px; 
    }
`;

export const StyledPageSubtitle = styled.p`
    color: black;
    font-size: 15px; 
    font-family: Roboto Condensed, serif;
    letter-spacing: 1px;
`;
